<template>
  <NButton btn="solid-orange">
    Solid Orange Button
  </NButton>
</template>
